/// <amd-module name="SuiteCommerce.Blog.EmptyState.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.EmptyState.View", ["require", "exports", "Backbone", "sc_blog_home_empty_state.tpl"], function (require, exports, Backbone_1, emptyStateTemplate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EmptyStateView = void 0;
    var EmptyStateView = /** @class */ (function (_super) {
        __extends(EmptyStateView, _super);
        function EmptyStateView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.template = emptyStateTemplate;
            return _this;
        }
        EmptyStateView.prototype.getContext = function () {
            return {
                label: this.model.label,
                message: this.model.message,
                buttonLabel: this.model.actionButtonLabel,
                buttonUrl: this.model.actionButtonUrl,
            };
        };
        return EmptyStateView;
    }(Backbone_1.View));
    exports.EmptyStateView = EmptyStateView;
});
